import { render } from "./SharedFileList.vue?vue&type=template&id=006a6f17&scoped=true"
import script from "./SharedFileList.vue?vue&type=script&lang=js"
export * from "./SharedFileList.vue?vue&type=script&lang=js"

import "./SharedFileList.vue?vue&type=style&index=0&id=006a6f17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006a6f17"]])

export default __exports__